import { Box, Typography, useMediaQuery } from "@mui/material";
import useThemeRender from "../../../../../theme/useThemeRender";
import "../../SpecialProject/SpecialProject.css";
import { Button } from "pepsico-ds";
const BuilderFooter = ({ label, form, handleBack, disabled }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        background: useThemeRender("insideCardBackgroundColorLayer1"),
        flexDirection: isMobile ? "column" : " ",
        gap: "12px",
        width: "100%",
        justifyContent: "center",
      }}
      className="ButtonBotttomBoxStyle"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: isMobile ? "center" : "flex-end",
          gap: "15px",
          width: "100%",
          flexDirection: isMobile ? "column" : " ",
        }}
      >
        <Button
          text="Cancel"
          variant="secondary"
          style={{
            width: isMobile ? "100%" : " ",
            display: "flex",
            justifyContent: "center",
          }}
          onClick={handleBack}
        />
        <Button
          type="submit"
          form={form}
          text={label}
          data-testid="submit-button"
          style={{
            width: isMobile ? "100%" : " ",
            display: "flex",
            justifyContent: "center",
          }}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};

export default BuilderFooter;
